import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PropertyListener } from '@vsolv/dev-kit/rx';
import { Staff } from '@wsphere/staff/domain';
import { BehaviorSubject, map } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-role-badge',
  templateUrl: './role-badge.component.html',
  standalone: false,
})
export class RoleBadgeComponent {
  @PropertyListener('permissionKey') permissionKey$ = new BehaviorSubject<string | null | undefined>(undefined);
  @Input() permissionKey?: string | null;

  @PropertyListener('roleId') roleId$ = new BehaviorSubject<string | null | undefined>(undefined);
  @Input() set roleId(roleId: string) {
    this.role = Staff.Security.getRole(roleId);
    this.resolvePermissions();
  }

  // Optional override for the permissions the badge lists. When custom roles are enabled, callers pass the
  // DB-authoritative permissions so the tooltip reflects edits; otherwise the badge falls back to the registry.
  @Input() set permissions(permissions: Staff.Security.Permission[] | undefined) {
    this.permissionsOverride = permissions;
    this.resolvePermissions();
  }

  @Input() removable = false;
  @Input() showPermissionKeyLabel = false;

  @Output() removed = new EventEmitter();

  role?: Staff.Security.Role;
  permissionList?: Staff.Security.Permission[];
  private permissionsOverride?: Staff.Security.Permission[];

  private resolvePermissions() {
    if (this.permissionsOverride) this.permissionList = this.permissionsOverride;
    else if (this.role) this.permissionList = Staff.Security.getPermissionsFromRoles([this.role.id]);
    else this.permissionList = undefined;
  }

  permissionKeyLabel$ = this.permissionKey$.pipe(
    map(permissionKey => {
      if (!permissionKey) return '(Global)';
      return `(${permissionKey})`;
    })
  );

  remove() {
    if (!this.removable) return;
    this.removed.emit(this.role?.id);
  }
}
